<template>
  <div class="ele-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/elegance/banner.jpg">
    <div class="site-text__content">
      <h3 class="text-blue site-text__content_h3">风华荟</h3>
      <div class="site-text__content_desc">
        <p data-aos="fade-right" data-aos-delay="100" data-aos-once="true">有境界者，自成高格，为塔尖生活，匹配非凡想象</p>
        <p data-aos="fade-right" data-aos-delay="200" data-aos-once="true">基于高净值业主眼界与品味的默契，风华系推出定制化服务平台--风华荟</p>
        <p data-aos="fade-right" data-aos-delay="300" data-aos-once="true">以“品质+会所+服务”为主旨，打造高端生活艺术的分享领地</p>
        <p data-aos="fade-right" data-aos-delay="400" data-aos-once="true">为业主提供更多尊享服务</p>
      </div>
    </div>
    <div class="grid-content">
      <h3 class="text-blue">风华荟成员6大权益</h3>
      <div class="grid-bg">
        <div v-for="(item,index) in cultureList"
             class="grid-item"
             :key="index"
             data-aos="fade-up"
             data-aos-once="true"
             :data-aos-delay="index*100"
             >
          <img :src="require('@/assets/elegance/'+item.image)">
          <div class="title-strong" data-aos="fade-up" data-aos-delay="100" data-aos-once="true">{{item.title}}</div>
          <div data-aos="fade-up" data-aos-delay="200" data-aos-once="true">
            <div class="tip">{{item.tip}}</div>
            <div class="tip">{{item.tip2}}</div>
            <div class="tip">{{item.tip3}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import topNav from '@/components/base/top-nav'
import $ from 'jquery';
export default {
  name: "elegance",
  components:{
    topNav
  },
  data() {
    return {
      lastScrollTop: 0, // 记录上次滚动位置
      cultureList:[
        {
          image:'1.jpg',
          title:'+HOME会所优享礼',
          tip:'会所活动场所优先',
          tip2:'预约子女可享骄子计划八折礼遇',
          tip3:'专属课程与私教额外享九折礼遇'
        },{
          image:'2.jpg',
          title:'+HOME咖啡&私宴荣享礼',
          tip:'咖啡吧、私宴套餐额外享九折礼遇',
          tip2:'会所活动场地使用额外享九折礼遇',
          tip3:''
        },{
          image:'3.jpg',
          title:'商业&酒店尊享礼',
          tip:'尊享嘉宏合作品牌专属折扣礼遇',
          tip2:'嘉宏商场，灯贸中心，酒店享优惠礼遇',
          tip3:'生日月酒店餐厅享额外八折礼遇'
        },{
          image:'4.jpg',
          title:'房产老带新&复购专享礼',
          tip:'老友引新及复购嘉宏住宅',
          tip2:'可在原政策之上享物业费礼遇',
          tip3:''
        },{
          image:'5.jpg',
          title:'房屋租售悦享礼',
          tip:'优先享受嘉宏房屋租售服务',
          tip2:'房屋租售服务费享额外八折礼遇',
          tip3:''
        },{
          image:'6.jpg',
          title:'高端圈层雅享礼',
          tip:'季度至少1次高端社群活动',
          tip2:'运动、教育、健康、旅游艺术品鉴，圈层俱乐部等',
          tip3:''
        }
      ],
    }
  },
  mounted() {
    console.log('mounted===')
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听
    // window.removeEventListener('scroll');
  },
  methods: {
    recordScrollPosition() {
      console.log("recordScrollPosition",this.lastScrollTop)
      // 记录当前滚动位置
      this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    lookMore() {
      this.cultureList.push({
        image:'',
        tip:''
      })
      this.cultureList.push({
        image:'',
        tip:''
      })
      this.cultureList.push({
        image:'',
        tip:''
      })
      // window.scrollTo(0, this.lastScrollTop);
    }
  }
}
</script>

<style>
  @import "../../styles/elegance.css";
</style>
<style lang="scss">
  /* 添加一个额外的类名来应用自定义动画 */
  @mixin custom-delay($delay) {
    /* 设置动画延迟时间为1.5秒 */
    animation-delay: $delay;
    /* 设置动画延迟时间为1.5秒 */
    -webkit-animation-delay: $delay;
    /* 设置动画延迟时间为1.5秒 */
    -moz-animation-delay: $delay;
    /* 设置动画延迟时间为1.5秒 */
    -o-animation-delay: $delay;
  }
  .delay1 {
    @include custom-delay(0.5s);
  }
  .delay2{
    @include custom-delay(1.5s);
  }
</style>
